import React, { memo } from 'react'
import tw from 'twin.macro'
import { Tooltip, Typography } from '@mui/material'
import { GSIcon } from 'src/components/shared/GSIcon'
import { ContractorRecollection, RecollectionType } from 'src/interfaces/contractor'
import { RecollectionTooltipContent } from './RecollectionTooltipContent'

interface RecollectionBadgeProps {
  recollection: ContractorRecollection
  muted?: boolean
}

const RecollectionBadgeComponent = ({ recollection, muted = false }: RecollectionBadgeProps) => {
  const isManual = recollection.type === RecollectionType.Manual

  return (
    <Tooltip
      title={<RecollectionTooltipContent recollection={recollection} />}
      placement="bottom-start"
      slotProps={{
        tooltip: {
          sx: {
            width: 275,
            padding: '12px 16px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '4px',
          },
        },
      }}
    >
      <div
        css={[
          tw`flex items-center gap-1 cursor-default hover:text-black`,
          muted ? tw`text-[#847E96]` : tw`text-black`,
        ]}
      >
        <GSIcon
          iconName="gs_arrows_repeat_right_left"
          width={20}
          height={20}
          stroke="currentColor"
        />
        <Typography variant="subtitle2" color="inherit" css={tw`font-semibold`}>
          {isManual ? 'M' : 'A'}
        </Typography>
      </div>
    </Tooltip>
  )
}

export const RecollectionBadge = memo(RecollectionBadgeComponent)
